<template>
	<div
		style="width: 95%"
		class="ml-5"
	>
		<loading-overlay
			:active="isLoading"
			:can-cancel="true"
		/>
		<base-block
			title="API Permissions"
			header-bg
		>
			<div
				ref="apiPermissionsTable"
			/>
		</base-block>
	</div>
</template>
